import React, { useEffect, useState } from "react";
import {
  Layout,
  Typography,
  Avatar,
  Button,
  Form,
  Input,
  Card,
  Modal,
  message,
} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { BASE_URL } from "./config";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

function User() {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/login");
    }
  }, [navigate]);

  if (!user) return null;

  const handlePasswordChange = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      message.error("New password and confirm password do not match!");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/change_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.email,
          oldPassword,
          newPassword,
        }),
      });

      const result = await response.json();

      if (result.success) {
        message.success("Password changed successfully!");
        form.resetFields();
        setIsModalVisible(false);
      } else {
        message.error(result.message || "Password change failed");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      message.error("Something went wrong. Please try again.");
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
      {/* Sidebar */}
      {Sidebar && (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          breakpoint="md"
          collapsedWidth="0"
          width={220}
          style={{ background: "#fff" }}
        >
          <Sidebar collapsed={collapsed} user={user} />
        </Sider>
      )}

      <Layout>
        <HeaderBar title="Profile" />

        <Content
          style={{
            margin: 5,
            background: "#f5f6fa",
            minHeight: "calc(100vh - 112px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 20,
          }}
        >
          {/* User Info Card */}
          <Card
            style={{
              width: "100%",
              maxWidth: 600,
              flex: "1 1 100%",
              background: "#fff",
              borderRadius: 12,
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              padding: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 20,
                justifyContent: "center",
              }}
            >
              <Avatar
                size={80}
                src={user.logo || null}
                icon={!user.logo && <UserOutlined />}
              />
              <Title level={4} style={{ marginLeft: 16, marginBottom: 0 }}>
                {user.username}
              </Title>
            </div>

            <Form layout="vertical">
              <Form.Item label="Email">
                <Input value={user.email} readOnly />
              </Form.Item>
              <Form.Item label="Company Name">
                <Input value={user.company_name || "No Company"} readOnly />
              </Form.Item>
              <Form.Item label="Company Website">
                <Input value={user.company_website || "Not Provided"} readOnly />
              </Form.Item>
              <Form.Item label="Phone Number">
                <Input value={user.phone || "Not Provided"} readOnly />
              </Form.Item>
              <Form.Item label="Country">
                <Input value={user.country || "Not Provided"} readOnly />
              </Form.Item>

              <Button
                type="primary"
                block
                style={{ marginTop: 16 }}
                onClick={() => navigate("/dashboard")}
              >
                Back to Dashboard
              </Button>
            </Form>
          </Card>

          {/* Change Password (moves below on small screens) */}
          <div
            style={{
              width: "100%",
              maxWidth: 250,
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <Button
              type="default"
              onClick={() => setIsModalVisible(true)}
              style={{
                fontWeight: 500,
                height: 45,
                width: "100%",
              }}
            >
              Change Password
            </Button>
          </div>
        </Content>

        <Footer user={user} />

        {/* Password Modal */}
        <Modal
          title={
            <span>
              <LockOutlined /> Change Password
            </span>
          }
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          centered
        >
          <Form form={form} layout="vertical" onFinish={handlePasswordChange}>
            <Form.Item
              label="Old Password"
              name="oldPassword"
              rules={[{ required: true, message: "Enter old password" }]}
            >
              <Input.Password placeholder="Enter old password" />
            </Form.Item>

            <Form.Item
              label="New Password"
              name="newPassword"
              rules={[{ required: true, message: "Enter new password" }]}
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              rules={[{ required: true, message: "Confirm new password" }]}
            >
              <Input.Password placeholder="Confirm new password" />
            </Form.Item>

            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form>
        </Modal>
      </Layout>
    </Layout>
  );
}

export default User;
